import GAHooks from '@/utils/ga-manager/composables/ga-hooks';
import { GAEvent } from '@/utils/ga-manager/composables/ga-event';
const GAManager = {
    hooks: GAHooks,
    sendEvent: GAEvent,
};
export default GAManager;
